export enum LoadFilesTypes {
    UPDATE_FILE = '@@LoadFile/UPDATE_FILE',
    UPDATE_FILE_SUCCESS = '@@LoadFile/UPDATE_FILE_SUCCESS',
    UPDATE_FILE_FAIL = '@@LoadFile/UPDATE_FILE_FAIL',
}